import {
  AtlasColor,
  PageContentAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import { StackAtom } from 'components/atoms/Stack.atom'
import { PalletCardOrganism } from 'components/organisms/PalletCard.organism'
import { usePalletsList } from './PalletsList.hook'

const PalletsListPage = () => {
  const { actions, pallets } = usePalletsList()

  return (
    <>
      <ToolbarMolecule
        title="Tarimas"
        actionIcon="close"
        onAction={actions.onGoBack}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={16}>
          {pallets.map((pallet) => (
            <PalletCardOrganism
              key={pallet.id}
              totalSKUs={pallet.totalSKUs}
              container={pallet.id}
              location={pallet.location}
              customIconName="ic_view"
              customIconColor={AtlasColor.Primary}
              onClickIcon={() => {
                actions.goToPalletDetail(pallet)
              }}
            />
          ))}
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default PalletsListPage
